import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addRejectReason,
  deleteRejectReason,
  getRejectReason,
  updateRejectReason,
} from "store/services/dataManagement/rejectReason";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

//Get All Reject Reason
export const GetAllRejectReasonAction = createAsyncThunk(
  "rejectReason/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getRejectReason(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

//Delete Reject Reason
export const DeleteRejectReasonAction = createAsyncThunk(
  "rejectReason/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, ...rest } = payload;
      const res = await deleteRejectReason(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        const responce = await getRejectReason(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

//Update Reject Reason
export const UpdateRejectReasonAction = createAsyncThunk(
  "rejectReason/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;

    try {
      const res = await updateRejectReason(rest);

      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());

        if (onSuccess) {
          onSuccess();
        }

        return fulfillWithValue(res);
      }

      if (onError) {
        onError();
      }

      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      if (onError) {
        onError();
      }

      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);

//Add Reject Reason
export const AddRejectReasonAction = createAsyncThunk(
  "rejectReason/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, filter, ...rest } = payload;

    try {
      const res = await addRejectReason(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());
        const responce = await getRejectReason(filter);
        if (responce.status === 1) {
          if (onSuccess) onSuccess();

          return fulfillWithValue(responce);
        }
      }
     if (onError) onError();
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      if (onError) onError();
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);
